<script setup lang="ts">
import { Card } from "@/components/ui/card";
import CardDecorator from "@/components/landing/card-decorator.vue";
import type { Component } from "vue";

interface FeatureCardProps {
  icon?: Component;
  title?: string;
  description: string;
  className?: string;
  variant?: "default" | "centered";
}

const props = withDefaults(defineProps<FeatureCardProps>(), {
  variant: "default",
});

const isDefault = props.variant === "default";
const hasHeader = isDefault && props.icon && props.title;


</script>

<template>
  <Card
    :class="[
      'group relative rounded-none shadow-zinc-950/5',
      isDefault ? '' : 'p-6',
      className,
    ]"
  >
    <CardDecorator />

    <div v-if="hasHeader" class="pb-3">
      <div class="p-6">
        <span class="text-muted-foreground flex items-center gap-2">
          <component :is="icon" class="size-4" />
          {{ title }}
        </span>
        <p class="mt-8 text-2xl font-semibold">
          {{ description }}
        </p>
      </div>
    </div>

    <p
      v-else-if="!isDefault"
      class="mx-auto my-6 max-w-md text-balance text-center text-2xl font-semibold"
    >
      {{ description }}
    </p>

    <slot />
  </Card>
</template>


